export const commonStyles = {
  ul: {
    listStyleType: 'disc',
    marginLeft: '15px',
  },
  emphasis: {
    fontWeight: 'bold',
  },
};
